module.exports = {
      id: "audio-forward-usage",
      viewBox: "0 0 512 512",
      url: "/" + "sprite-326d1762f7ed1f924194ae9c5468ee69.svg#audio-forward",
      toString: function () {
        return this.url;
      }
    }